import { connect } from 'react-redux'
import { getRecentShipments } from 'utils/actions/shipments'
import { RecentShipments as RecentShipmentsComponent } from '../RecentShipments'

export const RecentShipments = connect(
  ({
    userProfile: { userProfileDetails },
    recentShipments: {
      error,
      isFetching: fetching,
      params: {
        filters: { usersId },
      },
      shipmentList: shipments,
    } = {},
  }) => ({
    userId: userProfileDetails ? userProfileDetails.id : null,
    fetching,
    error,
    dataLoadedForUserId: usersId,
    shipments,
  }),
  { getShipments: getRecentShipments }
)(RecentShipmentsComponent)
